const getTopLevelDomain = (host = '') => {
  const parts = host.split('.');
  return parts.slice(-2).join('.');
};

export default getTopLevelDomain;
